/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Ai_TitleInputs */

const da_privacy_ai_title = /** @type {(inputs: Privacy_Ai_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sådan bruger vi AI`)
};

/** @type {(inputs: Privacy_Ai_TitleInputs) => LocalizedString} */
const en_privacy_ai_title = da_privacy_ai_title;

/**

* @param {Privacy_Ai_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_ai_title = /** @type {((inputs?: Privacy_Ai_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Ai_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_ai_title(inputs)
	return /** @type {LocalizedString} */ ("Sådan bruger vi AI")
});